// A1-105 (operator 2026-10-30: "I have no clue what it says and what to do";
// 2026-10-31 "ok on redesign", short form) — the head of every opened card,
// the same three lines on each: what happened, why it matters (rows, their
// figures, and what the card does to filing), what to do. The answers and the
// way out follow below, as before. The (i) keeps the long text and the code.
import React from "react";
import { fmtMoney } from "../../lib/format";
import { cardInstruction } from "./cardInstruction";   // A2-637 Owner B

const STAKE = {
  must: ["ui.review_grouped.stake_must", "Stops filing until it is answered."],
  check: ["ui.review_grouped.stake_check", "Worth checking: fix it, or leave it as it is with one click."],
};

// A2-637 Owner C: the server's tier says when a card stops filing (a
// duplicates card holding an exact copy stops filing, though Family A)
export const stakeOf = (g) => (g.family === "B" || g.tier === "must" ? "must" : g.tier === "info" ? "info" : "check");

// A card's figures, each currency on its own (never one sum under one label):
// the largest three and how many more.
export const amountsText = (amounts, t) => {
  const shown = amounts.slice(0, 3).map((a) => `${fmtMoney(a.gross)}${a.currency ? ` ${a.currency}` : ""}`).join(" · ");
  const more = amounts.length - 3;
  return more > 0
    ? t("ui.review_grouped.amounts_more", { shown, n: more, defaultValue: "{{shown}} + {{n}} more currencies" })
    : shown;
};

export const figuresLine = (g, t) => t("ui.review_grouped.figures_line", {
  n: g.count,
  figures: amountsText((g.amounts || []).length ? g.amounts : [{ currency: g.currency, gross: g.total_gross }], t),
  defaultValue: "{{n}} rows, {{figures}}",
});

const Line = ({ label, children, testid }) => (
  <div data-testid={testid} className="flex items-start gap-1.5 max-w-[70ch] leading-relaxed">
    <span className="font-semibold shrink-0 text-slate-800 dark:text-slate-100">{label}</span>
    <span>{children}</span>
  </div>
);

export const CardSummary = ({ g, t }) => {
  const stake = stakeOf(g);
  const done = (g.count || 0) > 0 && (g.acknowledged_count || 0) >= g.count;
  // A2-637 Owner B: "with one click" only where the card draws its one-click
  // keep (card map A/B-6: the promise stood on cards that had none)
  const oneClick = (g.actions || []).some((a) => a.kind === "KEEP" && a.all);
  const [key, fallback] = done
    ? ["ui.review_grouped.stake_done", "Every row is answered."]
    : stake === "check" && g.actions && !oneClick
      ? ["ui.review_grouped.stake_check_plain", "Worth checking before you file."]
      : STAKE[stake] || [];
  return (
    <div data-testid={`rg-summary-${g.flag_type}`} className="space-y-1 text-[12px] text-slate-700 dark:text-slate-200">
      <Line testid={`rg-summary-what-${g.flag_type}`}
        label={t("ui.review_grouped.what_happened", { defaultValue: "What happened:" })}>
        {t(`flags.${g.flag_type}`, { defaultValue: t(`flag_titles.${g.flag_type}`, { defaultValue: g.flag_type }) })}
      </Line>
      {/* a note says what it records; its own line already says "nothing to do" */}
      {stake !== "info" && (
        <Line testid={`rg-summary-why-${g.flag_type}`}
          label={t("ui.review_grouped.why_it_matters", { defaultValue: "Why it matters:" })}>
          {figuresLine(g, t)}. {t(key, { defaultValue: fallback })}
        </Line>
      )}
      {stake !== "info" && (
        <Line testid={`rg-summary-todo-${g.flag_type}`}
          label={t("ui.review_grouped.what_to_do", { defaultValue: "What to do:" })}>
          {cardInstruction(g, t)}
        </Line>
      )}
    </div>
  );
};

export default CardSummary;
